// extracted by mini-css-extract-plugin
module.exports = {"mail":"Compte_mail__a7zvN","titre":"Compte_titre__L5OAQ","warning":"Compte_warning__3rHi0","mobile":"Compte_mobile__2_Qmx","desktop":"Compte_desktop__1yG-b"};